export const MAP_COMPLETE_TO_APPLICATION_STATUS = {
  closed: "completed",
  declined: "completed",
  paid: "completed",
  cancelled: "cancelled"
};